import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Shimmer, ShimmerElementsGroup, ShimmerElementType, mergeStyles } from '@fluentui/react';
import { STEP_PATHS } from '../../steps/step-constants';

const PANEL_CONFIGS = {
  [STEP_PATHS.ASSETS]: {
    rowCount: 6,
    hasImages: true,
  },
  [STEP_PATHS.PRODUCTS]: {
    rowCount: 2,
  },
  [STEP_PATHS.TARGETING]: {
    rowCount: 3,
  },
  [STEP_PATHS.CAMPAIGNDETAILS]: {
    rowCount: 3,
  },
  [STEP_PATHS.BUDGET]: {
    rowCount: 3,
  },
};

const wrapperClass = mergeStyles({
  padding: 2,
  width: 700,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
    },
  },
});

const getPanelTitleShimmer = () => (
  <ShimmerElementsGroup
    width="100%"
    shimmerElements={[
          { type: ShimmerElementType.line, width: 200, height: 60 },
          { type: ShimmerElementType.gap, width: '80%', height: 60 },
          { type: ShimmerElementType.line, width: 100, height: 60 },
        ]}
  />
);

const getSummaryRowElement = isLastRow => (
  <>
    <ShimmerElementsGroup
      width="100%"
      shimmerElements={[
          { type: ShimmerElementType.line, width: 200, height: 20 },
          { type: ShimmerElementType.gap, width: 30, height: 20 },
        ]}
    />
    {!isLastRow && <Shimmer shimmerElements={[{ type: ShimmerElementType.gap, width: '100%', height: 10 }]} />}
  </>


);

const getSummaryImageRowElement = (isLastRow) => {
  const shimmerElements = [{ type: ShimmerElementType.line, width: 200, height: 50 }];

  // add 3 images
  _.range(3).forEach(() => {
    shimmerElements.push({ type: ShimmerElementType.gap, width: 30, height: 50 });
    shimmerElements.push({ type: ShimmerElementType.line, width: 100, height: 50 });
  });

  // add gap
  shimmerElements.push({ type: ShimmerElementType.gap, width: '100%', height: 50 });

  return (
    <>
      <ShimmerElementsGroup width="100%" shimmerElements={shimmerElements} />
      {!isLastRow && <Shimmer shimmerElements={[{ type: ShimmerElementType.gap, width: '100%', height: 10 }]} />}
    </>
  );
};

const getPanel = ({ rowCount, hasImages }) => {
  const title = getPanelTitleShimmer();

  const rows = Array.from({ length: rowCount }, (value, index) => (hasImages && index === 1
    ? getSummaryImageRowElement(index === rowCount - 1)
    : getSummaryRowElement(index === rowCount - 1)));

  return (
    <div style={{ marginTop: 50 }}>
      <Shimmer customElementsGroup={title} />
      <br />
      <Shimmer customElementsGroup={rows} />
    </div>
  );
};

export const SummaryShimmer = ({
  currentSteps = [],
  panelConfigs = PANEL_CONFIGS,
}) => {
  const panels = currentSteps.map((step) => {
    const panelConfig = panelConfigs[step];
    return panelConfig && getPanel(panelConfig);
  });

  return <div className={wrapperClass}>{panels}</div>;
};

SummaryShimmer.propTypes = {
  currentSteps: PropTypes.arrayOf(PropTypes.shape({})),
  panelConfigs: PropTypes.shape({}),
};

SummaryShimmer.defaultProps = {
  currentSteps: [],
  panelConfigs: PANEL_CONFIGS,
};

